import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__images } from '../STATE__images';

export const REMOTE__images_load_by_hash_content = createAsyncThunkSafe<void, string[]>(
  ENUM__network_event_client_to_server.IMAGES_LOAD_BY_HASH_CONTENT,
  async (hashes_content): Promise<any> => {
    await send_to_server(ENUM__network_event_client_to_server.IMAGES_LOAD_BY_HASH_CONTENT, hashes_content);
  },
);

export function INIT_REMOTE__images_load_by_hash_content(builder: ActionReducerMapBuilder<STATE__images>) {
  builder
    .addCase(REMOTE__images_load_by_hash_content.pending, (state, action) => {})
    .addCase(REMOTE__images_load_by_hash_content.rejected, (state, action) => {})
    .addCase(REMOTE__images_load_by_hash_content.fulfilled, (state, action: PayloadAction) => {});
}
